import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService, LazyLoadEvent } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { ActivityScheduleService } from '../activity-schedule.service';
import { ActivitySchedule } from '../activity-schedule';
import { ActivityService } from '@app/_components/activity';
import { PictureService } from '@app/_components/picture/picture.service';
import { Image } from '../../property/image/property-image';
import { SpringQuery } from '@app/_helpers/spring-query';
import { first } from 'rxjs';

@Component({
    selector: 'app-activity-schedule',
    templateUrl: './activity-schedule.component.html',
    styleUrls: ['./activity-schedule.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ActivityScheduleComponent implements OnInit {
    activityFeeId: any;
	activityFeeIdRequired = false;

	// data
	uploadedFiles: any[] = [];
	pictureArray: any[] = [];
	pictures: any[] = [];
	pictureSorting: any[] = [];
	image: Image;
	images: any[] = [];
	forDeletePictures: any[] = [];


	// datalist
	lazyLoadEvent: LazyLoadEvent;
	recordTotal: number;
	loading = true;
	multiSortMeta = [];
	first = 0;
	rows = 50;

	pictureProperties: any = {};
	pictureData: any;
    pictureIndex: number;
	isPicture = false;

	constructor(
		private activityService: ActivityService,
		private primengConfig: PrimeNGConfig,
		private activityScheduleService: ActivityScheduleService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private pictureService: PictureService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.activitySchedule = data.activitySchedule,
			this.activityFeeId = data.activityFeeId,
			this.statuses = activityScheduleService.statuses;
	}

	@Input() activitySchedule: ActivitySchedule;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	activityScheduleId: number;
	activitys: any;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	columns: any[] = [
		{ field: 'pictureId', header: 'pictureId', width: 'auto' },
	];

	validationMessages = {
		'activityScheduleId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [
			{ type: 'required', message: 'Required' }
		],
		'status': [],
		'season': [],
		'startTime': [],
		'endTime': [],
		'startTimeDesc': [],
		'endTimeDesc': [],
		'duration': [],
		'activityFeeId': [],
	};
	
	ngOnInit() {
		this.fetchActivitys();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole activitySchedule object
		if (this.activitySchedule) {
			// this.activitySchedules.forEach(activitySchedule => {
				this.activitySchedule.startTime = this.getTime(this.activitySchedule.startTime);
				this.activitySchedule.endTime = this.getTime(this.activitySchedule.endTime);
			// });
			this.activityScheduleId = this.activitySchedule.activityScheduleId;
			this.fixDates();
			this.form1.patchValue(this.activitySchedule);
		}
	}

	getTime(dateTime: any) {
		return moment(dateTime).format("HH:mm A");
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.activityScheduleId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			if(this.form1.value.activityFeeId == null && this.form1.value.activityFeeId == undefined && this.form1.value.activityFeeId == "undefined"){
				this.form1.value.activityFeeId = this.activityFeeId;
			}
			if(this.form1.value.activityFeeId == null && this.activityFeeId == null){
				this.activityFeeIdRequired = true;
				this.messageService.add({ severity: 'error', summary: 'Validation Error', detail: "Activity is required" });
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.activityScheduleService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.activitySchedule = res.data.activitySchedule;
						this.doAdd.emit(this.activitySchedule);
					},
					(err: any) => {
						console.log('activitySchedule-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('activitySchedule: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.activityScheduleService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.activitySchedule = res.data.activitySchedule;
						this.doUpdate.emit(this.activitySchedule);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.activityScheduleService.delete(this.activitySchedule.activityScheduleId)
				.subscribe(
					(res: any) => {
						console.log('activitySchedule-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.activitySchedule);
					},
					(err: any) => {
						console.log('activitySchedule-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			activityScheduleId: [this.activityScheduleId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			description: [],
			status: [],
			season: [],
			startTime: [],
			endTime: [],
			startTimeDesc: [],
			endTimeDesc: [],
			duration: [],
			activityFeeId: [this.activityFeeId],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.activitySchedule.activityScheduleDate = moment(this.activitySchedule.activityScheduleDate).toDate();
	}
	
	fetchActivitys() {
		if (!this.activitys || this.activitys === undefined || this.activitys.length < 1) {
			try {
				this.activityService.findAll()
					.subscribe(
						res => {
							console.log('findAllActivitySummary: ' + JSON.stringify(res));
							this.activitys = res.data.activitys;
							return this.activitys;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.activitys);
		}
	}
	
	selectActivity(){
		this.activityFeeIdRequired = false;
	}

	addIntoCheckedList(picture: any){
		if (this.forDeletePictures.includes(picture.pictureId)) {
			this.forDeletePictures.splice(this.forDeletePictures.indexOf(picture.pictureId), 1);
		}else{
			this.forDeletePictures.push(picture.pictureId);
		}
		console.log("forDeletePictures : "+this.forDeletePictures);
	}
	
	selectAllPictures(){
		this.forDeletePictures = [];
		for (var index in this.pictures) {
			this.pictures[index].checked = true;
			this.forDeletePictures.push(this.pictures[index].pictureId);
		}
		console.log("forDeletePictures after select all : "+this.forDeletePictures);
	}
	
	unSelectAllPictures(){
		this.forDeletePictures = [];
		for (var index in this.pictures) {
			this.pictures[index].checked = false;
		}
		console.log("forDeletePictures after deselect all : "+this.forDeletePictures);
	}

	/********** Delete Image from DB + S3 **********/
	onDelete(image) {
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + image.pictureId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				try {
					this.formLoading = true;
					this.pictureService.removePicture(image.pictureId)
						.subscribe(
							res => {
								console.log('formDelete SUCCESS: ' + JSON.stringify(res));
								this.pictures.splice(this.pictures.indexOf(image), 1);
								this.images = this.pictures;
								this.loadLazy(this.lazyLoadEvent);
								this.recordTotal = this.pictures.length;
								this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });

							},
							err => {
								console.log('formDelete FAIL: ' + JSON.stringify(err));
								this.formLoading = false;
								this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Delete failed: ' + err.message, sticky: true });
							},
							() => { this.formLoading = false; });

				} catch (error) {
					console.log('Form Invalid: ' + JSON.stringify(error));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'General error: ' + error, sticky: true });
				}
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}
	
	/********** Delete Image from DB + S3 **********/
	deleteMultiplePictures() {
		try {
					this.formLoading = true;
					this.pictureService.removeMultiplePicture(this.forDeletePictures)
						.subscribe(
							res => {
								console.log('formDelete SUCCESS: ' + JSON.stringify(res));
								for (let i = 0; i < this.forDeletePictures.length-1; i++) {
								  this.pictures.splice(this.pictures.indexOf(this.forDeletePictures[i]), 1);
								}
								this.forDeletePictures = [];
								this.images = this.pictures;
								this.loadLazy(this.lazyLoadEvent);
								this.recordTotal = this.pictures.length;
								this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });

							},
							err => {
								console.log('formDelete FAIL: ' + JSON.stringify(err));
								this.formLoading = false;
								this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Delete failed: ' + err.message, sticky: true });
							},
							() => { this.formLoading = false; });

				} catch (error) {
					console.log('Form Invalid: ' + JSON.stringify(error));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'General error: ' + error, sticky: true });
				}
	}


	/********** Load Images from DB **********/
	loadLazy(event: LazyLoadEvent) {
		try {
			this.formLoading = true;
			this.lazyLoadEvent = event;
			const pageNumber = Math.round(event.first / event.rows);

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			// If we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			let springQuery = new SpringQuery();
			springQuery.addEquals('size', '200');
			if (this.activityScheduleId) {
				springQuery.addEquals('activityScheduleVO.activityScheduleId', this.activityScheduleId.toString())
			}

			this.pictureService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters,
				springQuery).pipe(first()).subscribe(

					res => {
						console.log('Load SUCCESS: ' + JSON.stringify(res))
						this.pictures = res.data.pictures;
						if(this.pictures.length > 0){
							this.isPicture = false;
						}else{
							this.isPicture = true;
						}
						for (var index in this.pictures) {
							this.pictures[index].checked = false;
						}
						console.log("pppppppppppppppppppppppppppppppppppppppppppppppppppppppp : "+JSON.stringify(this.pictures));
						this.pictures.sort((t1, t2) => {
							if (t1.sortOrder > t2.sortOrder) {
								return 1;
							}

							if (t1.sortOrder < t2.sortOrder) {
								return -1;
							}

							return 0;
						});
						this.images = this.pictures;
						this.recordTotal = res.page.recordTotal;
						this.formLoading = false;
					},
					err => {
						console.log('Load FAIL: ' + JSON.stringify(err));
						this.formLoading = false;
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message, sticky: true });
					},
					() => { this.formLoading = false; }
				);

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, sticky: true });
		}
	}

	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		// this.onOpenFormEdit(event.data);
	}

	myUploader(event: any) {
		this.pictureIndex = 0;
		this.uploadedFiles = event.files;
		this.uploadPicture();
	}
	
	uploadPicture() {
		this.formLoading = true;
		console.log('File name: ' + JSON.stringify(this.uploadedFiles[this.pictureIndex].name));
		try {
			this.pictureService.uploadFileActivitySchedule(this.uploadedFiles[this.pictureIndex], this.activityScheduleId)
				.subscribe(
					res => {
						this.pictureIndex = this.pictureIndex + 1;
						if (this.uploadedFiles.length != this.pictureIndex) {
							this.uploadPicture();
						} else {
							this.isPicture = false;
							this.loadLazy(this.lazyLoadEvent);
							this.messageService.add({ severity: 'success', summary: 'Success', detail: "Upload All Image Successfully" });
							this.formLoading = false;
						}
						console.log('Update picture successfully: ' + JSON.stringify(res));
					},
					err => {
						this.pictureIndex = this.pictureIndex + 1;
						if (this.uploadedFiles.length != this.pictureIndex) {
							this.uploadPicture();
						} else {
							this.loadLazy(this.lazyLoadEvent);
							this.formLoading = false;
						}
						console.log('Update picture sort order FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { 
						if (this.uploadedFiles.length == this.pictureIndex) {
							this.loadLazy(this.lazyLoadEvent);
							this.formLoading = false;
						}
					});
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
		}
	}
}
